import { Button } from '@creditornot/cb-button';
import React, { useCallback, useMemo } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import StickyFooter from 'modules/menu/items/components/Item/ItemDetails/StickyFooter';

import { FormValues } from './OfferDetailsForm';
import { getTabsErrors } from './OfferDetailsForm/utils';
import { useOfferTabContext } from '../context/OfferTabContext';

type OfferStickyFooterProps = {
  onClose: () => void;
  isLoading: boolean;
  onSubmit: () => void;
};

const CancelButton = styled(Button).attrs({ size: 'small', variant: 'lightBlue' })`
  margin-inline-end: 16px;
`;

const SaveButton = styled(Button).attrs({ size: 'small', variant: 'blue' })``;

export const OfferStickyFooter = ({ onClose, isLoading, onSubmit }: OfferStickyFooterProps) => {
  const form = useForm<FormValues>();
  const { errors } = useFormState<FormValues>();
  const tabsErrors = useMemo(() => getTabsErrors(errors), [errors]);
  const formHasErrors = useMemo(() => Object.values(tabsErrors).some(errorCount => errorCount > 0), [tabsErrors]);

  const { showTabErrors } = useOfferTabContext();

  const highlightAllFieldsWithErrors = useCallback(() => {
    if (errors) {
      Object.keys(errors).forEach((fieldName: keyof FormValues) => form.blur(fieldName));
      showTabErrors();
    }
  }, [errors, form, showTabErrors]);

  return (
    <StickyFooter>
      <CancelButton variant="lightBlue" onClick={onClose} type="button">
        <FormattedMessage id="state.cancel" />
      </CancelButton>
      <SaveButton loading={isLoading} onClick={formHasErrors ? highlightAllFieldsWithErrors : onSubmit} type="submit">
        <FormattedMessage id="state.save" />
      </SaveButton>
    </StickyFooter>
  );
};
